import { useCallback, useState } from 'react'
import { Box, Button, Drawer, Fab, IconButton, Stack, Tooltip, Typography, useMediaQuery, useTheme } from '@mui/material'
import { Link as RouterLink, useLocation } from 'react-router-dom'
import { useAuth } from '../state/AuthContext'
import { useFiltros } from '../state/FiltrosContext'
import { ChatIA } from './ChatIA'
import { Hicon } from './Hicon'

// Telas em que o período do topo recorta os números: o chat aberto nelas usa esse período.
const PAINEIS = ['/trafego-pago', '/organico', '/redes-sociais']

/**
 * Botão flutuante que abre o chat numa gaveta, em qualquer tela (menos na própria página do
 * chat). A conversa é a mesma da página Pergunte à IA.
 */
export function ChatFlutuante() {
  const { pode } = useAuth()
  const { intervalo } = useFiltros()
  const { pathname } = useLocation()
  const theme = useTheme()
  const celular = useMediaQuery(theme.breakpoints.down('sm'))
  const [aberto, setAberto] = useState(false)
  const [limpar, setLimpar] = useState<(() => void) | null>(null)
  const guardarLimpar = useCallback((f: (() => void) | null) => setLimpar(() => f), [])

  if (!pode('paineis.ver') || pathname.startsWith('/chat')) return null
  const noPainel = PAINEIS.some((p) => pathname.startsWith(p))

  return (
    <>
      <Tooltip title="Pergunte à IA" placement="left">
        <Fab
          color="primary"
          aria-label="Pergunte à IA"
          onClick={() => setAberto(true)}
          sx={{ position: 'fixed', right: { xs: 16, sm: 24 }, bottom: { xs: 16, sm: 24 }, zIndex: (t) => t.zIndex.drawer - 1 }}
        >
          <Hicon name="activity" />
        </Fab>
      </Tooltip>
      <Drawer
        anchor="right"
        open={aberto}
        onClose={() => setAberto(false)}
        slotProps={{ paper: { sx: { width: celular ? '100%' : 460, display: 'flex', flexDirection: 'column' } } }}
      >
        <Stack direction="row" alignItems="center" spacing={1} sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider' }}>
          <Box sx={{ mr: 'auto', minWidth: 0 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 700, fontFamily: '"Outfit", sans-serif' }}>
              Pergunte à IA
            </Typography>
            <Typography variant="caption" color="text.secondary">
              {noPainel ? 'Usa o período e a marca desta tela quando a pergunta não disser.' : 'Números conferidos com os dados dos painéis.'}
            </Typography>
          </Box>
          {limpar ? (
            <Button size="small" onClick={limpar} sx={{ textTransform: 'none' }}>
              Nova
            </Button>
          ) : null}
          <Button size="small" component={RouterLink} to="/chat" onClick={() => setAberto(false)} sx={{ textTransform: 'none' }}>
            Tela cheia
          </Button>
          <IconButton aria-label="Fechar" onClick={() => setAberto(false)} size="small">
            <Box component="span" aria-hidden sx={{ fontSize: 22, lineHeight: 1 }}>
              ×
            </Box>
          </IconButton>
        </Stack>
        <Box sx={{ flex: 1, overflowY: 'auto', p: 2, display: 'flex', flexDirection: 'column' }}>
          <ChatIA compacto periodoTela={noPainel ? intervalo : undefined} onNovaConversa={guardarLimpar} />
        </Box>
      </Drawer>
    </>
  )
}
